import { render, staticRenderFns } from "./requestReReview.vue?vue&type=template&id=01a228de&scoped=true&"
import script from "./requestReReview.vue?vue&type=script&lang=js&"
export * from "./requestReReview.vue?vue&type=script&lang=js&"
import style0 from "./requestReReview.vue?vue&type=style&index=0&id=01a228de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a228de",
  null
  
)

export default component.exports